import { isDeliveryMode } from 'utils/appUtils'

export const cartUrl = () => (isDeliveryMode() ? '/cart/v4/' : '/cart/v4/pickup')

export const checkoutUrl = () =>
    isDeliveryMode() ? '/cart/v4/checkout' : '/cart/v4/checkout/pickup'

export const placeOrderUrl = () => (isDeliveryMode() ? '/cart/v4/orders' : '/cart/v4/orders/pickup')

export const saveJumio = '/jumio/jumio/getverifieddetails'

export const suggestiveSellingUrl = '/content/suggestions/search'

export const preOrderCancelUrl = '/order/cancel/preorder/{order_id}'
